import React from 'react';
import axios from 'axios';
import IMediaPlayer, { IMediaPlayerInstance } from '../models/IMediaPlayer';

import ReactPlayer from 'react-player';
import { callPlayer, getSDK, randomString } from '../utils';

const SDK_URL = '//cvp.twitch.tv/2.23.8/mediaplayer.min.js';
const SDK_GLOBAL = 'MediaPlayer';
const PLAYER_ID_PREFIX = 'amazon-ivs-';

export class AmazonIVS extends ReactPlayer {
  static displayName = 'AmazonIVS';
  static loopOnEnded = true;
  callPlayer = callPlayer;
  player: IMediaPlayerInstance | null = null;
  playerID = PLAYER_ID_PREFIX + randomString();
  retryInterval: any = null;
  static canEnablePIP() { return false; }

  attemptLoad() {
    axios.get(this.props.url as string)
      .then(() => {
        this.load(this.props.url as string);
        clearInterval(this.retryInterval);
      })
      .catch(() => null);
  }

  componentDidMount() {
    if (this.props.isLivestreamPreview && this.props.url) {
      this.retryInterval = setInterval(this.attemptLoad.bind(this), 3000);
    }
  }

  componentWillUnmount() {
    if (this.retryInterval) {
      clearInterval(this.retryInterval);
    }
  }

  getCurrentTime = (): number => {
    return this.callPlayer('getPosition');
  }
  getDuration(): number {
    return this.callPlayer('getDuration');
  }
  getMuted(): boolean {
    return this.callPlayer('isMuted');
  }
  getSecondsLoaded = (): number | null => {
    const duration = this.getDuration();
    if (!(duration && Number.isFinite(duration))) { return null; }
    const bufferedDuration = this.callPlayer('getBufferDuration');
    return duration + bufferedDuration;
  }

  getVolume() {
    return this.callPlayer('getVolume');
  }
  load(url: string) {
    if (this.player) {
      this.player.load(url);
      this.player.play();
      return;
    }
    getSDK<IMediaPlayer>(SDK_URL, SDK_GLOBAL).then((MediaPlayer) => {
      const { PlayerEvent, PlayerState } = MediaPlayer;
      this.player = MediaPlayer.create({});
      const element = document.getElementById(this.playerID) as HTMLVideoElement;
      this.player.attachHTMLVideoElement(element);
      this.player.addEventListener(PlayerEvent.ERROR, this.props.onError!);
      this.player.addEventListener(PlayerState.READY, this.props.onReady!);
      this.player.addEventListener(PlayerState.ENDED, this.props.onEnded!);
      this.player.addEventListener(PlayerState.IDLE, this.props.onPause!);
      this.player.addEventListener(PlayerState.PLAYING, this.props.onPlay!);
      this.player.setAutoplay(true);
      this.player.load(url);
      this.player.play();
    }, this.props.onError);
  }
  mute = () => {
    this.callPlayer('setMuted', true);
  }
  pause() {
    this.callPlayer('pause');
  }
  play() {
    this.callPlayer('play');
  }
  render() {
    const style = {
      height: '100%',
      width: '100%',
    };
    return (
      <video style={style} id={this.playerID} playsInline={true}/>
    );
  }
  seekTo = (seconds: number) => {
    const duration = this.getDuration();
    if (!(duration && Number.isFinite(duration))) { return; }
    this.callPlayer('seekTo', seconds);
  }
  setVolume(fraction: number) {
    this.callPlayer('setVolume', fraction);
  }
  stop() {
    this.callPlayer('delete');
  }
  unmute = () => {
    this.callPlayer('setMuted', false);
  }
}
